package app.bloomey.web.core.res


private const val icons = "/icons/"
val Res.Assets.logo: String
    get() = "/images/logo.svg"

val Res.Assets.icEnvelope: String
    get() = "${icons}ic_envelope.svg"
val Res.Assets.icPassword: String
    get() = "${icons}ic_password.svg"

val Res.Assets.icFilmSlate: String
    get() = "${icons}ic_film_slate.svg"

val Res.Assets.icPlay: String
    get() = "${icons}ic_play.svg"

val Res.Assets.icPlayFilled: String
    get() = "${icons}ic_play_filled.svg"
val Res.Assets.icUser: String
    get() = "${icons}ic_user.svg"

val Res.Assets.ic_doorOpen: String
    get() = "${icons}ic_door_open.svg"

val Res.Assets.icHome: String
    get() = "${icons}ic_house_simple.svg"

val Res.Assets.icClose: String
    get() = "${icons}ic_close.svg"
val Res.Assets.icTrash: String
    get() = "${icons}ic_trash.svg"

val Res.Assets.icChatCircle: String
    get() = "${icons}ic_chat_circle.svg"

val Res.Assets.googlePlay: String
    get() = "${icons}ic_google_play.svg"
val Res.Assets.apple: String
    get() = "${icons}ic_apple.svg"

val Res.Assets.imgThumbnail: String
    get() = "/images/videoThumbnail.png"

val Res.Assets.logoPattern: String
    get() = "/images/logo_pattern.svg"

val Res.Assets.app_preview: String
    get() = "/images/app_preview.png"

val Res.Assets.cookie: String
    get() = "/images/cookie.png"

val Res.Assets.signature: String
    get() = "/images/signature.png"